export default "__VITE_ASSET__DYgZvL3G__"